export default {
	URL: 'https://api-gsiagro.infinitum-ti.com',
	API_URL: 'https://api-gsiagro.infinitum-ti.com/api',
	OAPI_URL: 'https://api-gsiagro.infinitum-ti.com/oapi',
	// URL: 'http://localhost:5665',
	// API_URL: 'http://localhost:5665/api',
	// OAPI_URL: 'http://localhost:5665/oapi',
}
